import { render, staticRenderFns } from "./ProductSort.vue?vue&type=template&id=22c22aa2&"
import script from "./ProductSort.vue?vue&type=script&lang=js&"
export * from "./ProductSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports